/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
import { setupI18n } from '@lingui/core';
import { captureException } from '@sentry/browser';
import { en, es } from 'make-plural/plurals';

function oncePerInput(fn: Function) {
  let seen = new Set();

  function memoized(msg: string) {
    if (seen.has(msg)) {
      return;
    }

    seen.add(msg);
    fn(msg);
  }

  return memoized;
}

const warnOnce = oncePerInput(console.warn);

export function missingLocalizationWarning(language: string, key: string) {
  const warningMessage = `🚨 Unable to resolve localization key '${key}' for language '${language}'. See https://github.quartethealth.com/experience/coop/blob/dev/libs/localization/README.md`;
  if (process.env.NODE_ENV === 'production') {
    captureException(
      new Error(
        `🚨 Unable to resolve localization key '${key}' for language '${language}'. See https://github.quartethealth.com/experience/coop/blob/dev/libs/localization/README.md`
      )
    );
    return key;
  } else if (process.env.NODE_ENV === 'development') {
    warnOnce(warningMessage);
  }

  return `I18N_MISSING::${key}`;
}

export const i18n = setupI18n({
  missing: missingLocalizationWarning
});

export const init = () => {
  i18n.loadLocaleData({
    'en-US': { plurals: en },
    'es-US': { plurals: es }
  });
};
